import * as React from "react";
const SvgInviteArrow = props => <svg preserveAspectRatio="none" overflow="visible" style={{
  display: "block"
}} width={18} height={18} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g id="Frame"><path id="Vector" d="M3.75 9H14.25" stroke="black" style={{
      stroke: "black",
      strokeOpacity: 1
    }} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /><path id="Vector_2" d="M9 3.75L14.25 9L9 14.25" stroke="black" style={{
      stroke: "black",
      strokeOpacity: 1
    }} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g></svg>;
export default SvgInviteArrow;